import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { useI18n } from "../lib/i18n";
import { POLICIES, POLICY_VERSION } from "../lib/policies";

export default function Policy() {
  const { kind } = useParams();
  const { t, lang } = useI18n();
  const set = POLICIES[kind];
  if (!set) return <Navigate to="/policy/buyer" replace />;
  const sections = set[lang] || set.en;
  const other = kind === "buyer" ? "supplier" : "buyer";

  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-2">MQL STORE</div>
        <h1 data-testid="policy-title" className="text-4xl sm:text-5xl font-black text-[#F5F3ED] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t(`policy.${kind}`)}</h1>
        <div className="text-xs text-[#A8A8AD] mb-2">{t("policy.updated")} {POLICY_VERSION}</div>
        {!set[lang] && t("policy.lang_note") && <div data-testid="policy-lang-note" className="text-xs text-[#F2D98D] mb-2">{t("policy.lang_note")}</div>}
        <div className="space-y-6 mt-8">
          {sections.map(([h, p]) => (
            <section key={h} className="border-l-2 border-[#D4AF37]/60 pl-5">
              <h2 className="text-lg font-semibold text-[#F5F3ED] mb-1">{h}</h2>
              <p className="text-sm text-[#A8A8AD] leading-relaxed">{p}</p>
            </section>
          ))}
        </div>
        <Link to={`/policy/${other}`} data-testid={`policy-link-${other}`} className="inline-block mt-10 text-sm text-[#D4AF37] hover:underline">{t(`policy.${other}`)} →</Link>
      </div>
    </div>
  );
}
